import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button } from './Button';
import { Footer } from '../layout/Footer';
import { PageTransition } from './PageTransition';
import { SEO } from '../shared/SEO';

export const NotFound: React.FC = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language.startsWith('en') ? 'en' : 'id';
  
  return (
    <PageTransition>
      <SEO 
        title={t('404.title', 'Page Not Found')}
        description={t('404.description', 'The page you are looking for might have been removed or is temporarily unavailable.')}
        noindex={true}
      />
      <div className="min-h-screen flex flex-col">
        <main className="flex-grow bg-gray-900 flex items-center justify-center">
          <div className="w-full pt-36 pb-28">
            <div className="text-center px-4">
              <h1 className="text-9xl font-bold text-primary-500">404</h1>
              <h2 className="text-4xl font-semibold text-white mt-4">
                {t('404.title', 'Page Not Found')}
              </h2>
              <p className="text-gray-400 mt-4 text-lg">
                {t('404.description', 'The page you are looking for might have been removed or is temporarily unavailable.')}
              </p>
              <div className="mt-8 flex justify-center">
                <Link to={`/${currentLanguage}`}>
                  <Button className="animate-pulse hover:animate-none">
                    {t('404.backHome', 'Back to Home')}
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </PageTransition>
  );
}; 